import { accessRole } from "../../../../../../../helpers/access_role";
import { config } from "../../../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Tooltip } from "reactstrap";

import MKIDatatable from "../../../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../../../services/adapters/kepegawaian/diklatService";

import DataTableBloc from "../../../teknis/Index/Blocs/DiklatBloc";
import apiResponse from "../../../../../../../services/apiResponse";

import ReactTimeAgo from "react-time-ago";

class TableActiveComponent extends Component {
  // Retrieve Data Pegawai by Admin / Pegawai
  userdata = JSON.parse(localStorage.getItem("userdata"));
  employeeSeleted = JSON.parse(localStorage.getItem("employeeSelected"));
  peg_uuid = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_uuid
      : ""
    : this.employeeSeleted != null
    ? this.employeeSeleted.employee_uuid
    : "";

  dataTableBloc = new DataTableBloc();

  source;
  historyTable = "teknis_tabel";
  defaultOrder = "training_id";
  defaultSize = 10;
  defaultSort = "desc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      approveUuid: null,
      inactiveUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      employee_uuid: this.peg_uuid,
      training_type: 3,
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
    };
    await this.dataTableBloc.fetchRowTableAdmin(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.inactiveData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  inactiveData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.rowtableAdminChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.inactiveChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading: false,
              success: true,
              loadingTable: true,
            },
            function () {
              this.setTokenAPI();
              this.props.handleInactiveSuccess();
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.type !== this.props.type) {
      this.loadData();
    }
  }

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel?.unsubscribe();
  }

  columns = [
    {
      key: "training_employee_full_name",
      text: "Pegawai",
      sortable: true,
    },
    {
      key: "training_type_name",
      text: "Nama Diklat",
      sortable: true,
    },
    {
      key: "training_place",
      text: "Tempat",
      sortable: true,
      cell: (record) => {
        return record.training_city_name || record.training_city_text;
      },
    },
    {
      key: "training_organizer",
      text: "Penyelenggara",
      sortable: true,
    },
    {
      key: "training_year",
      text: "Tahun Diselenggarakan",
      sortable: true,
    },
    {
      key: "training_status_status_name",
      text: "Status",
      className: "training_status_status_name",
      sortable: true,
      width: "100",
      cell: (record) => {
        var status = record.training_status;
        var status_name = record.training_status_status_name;
        return (
          <span>
            {parseInt(status) == 1 ? (
              <label className="badge rounded-pill bg-soft-success font-size-12">
                {status_name}
              </label>
            ) : (
              <label className="badge rounded-pill bg-soft-warning font-size-12">
                {status_name}
              </label>
            )}
          </span>
        );
      },
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 120,
      sortable: false,
      align: "center",
      cell: (record) => {
        const thisId = record.training_id;
        const status = record.training_status;
        return (
          <Fragment>
            <span>
              <button
                className="btn btn-primary btn-sm"
                id={"detail-" + thisId}
                onClick={() => {
                  this.setState({
                    detailUuid: record.training_uuid,
                  });
                }}
                style={{
                  marginRight: "2px",
                  padding: "2px 5px",
                }}
              >
                <i className="uil-align-left"></i>
              </button>
              <Tooltip
                style={{
                  marginBottom: 2,
                }}
                placement="top"
                isOpen={this.state["detail" + thisId]}
                target={"detail-" + thisId}
                toggle={() => {
                  this.setState({
                    ["detail" + thisId]: !this.state["detail" + thisId],
                  });
                }}
              >
                Detil
              </Tooltip>
            </span>
            {accessRole("update") &&
            (parseInt(status) === 1 || parseInt(status) === 2) ? (
              <span>
                <button
                  className="btn btn-warning btn-sm"
                  id={"update-" + thisId}
                  onClick={() => {
                    this.setState({
                      updateUuid: record.training_uuid,
                    });
                  }}
                  style={{
                    marginRight: "2px",
                    padding: "2px 5px",
                  }}
                >
                  <i className="uil-pen"></i>
                </button>
                <Tooltip
                  style={{
                    marginBottom: 2,
                  }}
                  placement="top"
                  isOpen={this.state["update" + thisId]}
                  target={"update-" + thisId}
                  toggle={() => {
                    this.setState({
                      ["update" + thisId]: !this.state["update" + thisId],
                    });
                  }}
                >
                  Perbaharui
                </Tooltip>
              </span>
            ) : null}
            {accessRole("delete") && parseInt(status) == 1 ? (
              <span>
                <button
                  className="btn btn-danger btn-sm"
                  id={"delete-" + thisId}
                  onClick={() => {
                    this.setState({
                      inactiveUuid: record.training_uuid,
                      confirm: true,
                    });
                  }}
                  style={{
                    padding: "2px 5px",
                  }}
                >
                  <i className="uil-trash-alt"></i>
                </button>
                <Tooltip
                  style={{
                    marginBottom: 2,
                  }}
                  placement="top"
                  isOpen={this.state["delete" + thisId]}
                  target={"delete-" + thisId}
                  toggle={() => {
                    this.setState({
                      ["delete" + thisId]: !this.state["delete" + thisId],
                    });
                  }}
                >
                  Nonaktifkan
                </Tooltip>
              </span>
            ) : null}
            {accessRole("approve") && parseInt(status) === 0 ? (
              <span>
                <button
                  className="btn btn-success btn-sm"
                  id={"approve-" + thisId}
                  onClick={() => {
                    this.setState({
                      approveUuid: record.training_uuid,
                    });
                  }}
                  style={{
                    marginRight: "2px",
                    padding: "2px 5px",
                  }}
                >
                  <i className="uil-check"></i>
                </button>
                <Tooltip
                  style={{
                    marginBottom: 2,
                  }}
                  placement="top"
                  isOpen={this.state["approve" + thisId]}
                  target={"approve-" + thisId}
                  toggle={() => {
                    this.setState({
                      ["approve" + thisId]: !this.state["approve" + thisId],
                    });
                  }}
                >
                  Approve
                </Tooltip>
              </span>
            ) : null}
          </Fragment>
        );
      },
    },
  ];

  render() {
    return (
      <>
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menghapus data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil dihapus"
          failedTitle="Gagal!"
          failedInfo="Data gagal dihapus"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.detailUuid !== null ? (
          <Redirect
            uuid={this.state.detailUuid}
            to={`/kepegawaian/diklat/teknis.html?detail&uuid=${this.state.detailUuid}`}
          />
        ) : null}
        {this.state.updateUuid !== null ? (
          <Redirect
            uuid={this.state.detailUuid}
            to={`/kepegawaian/diklat/teknis.html?update&uuid=${this.state.updateUuid}`}
          />
        ) : null}
        {this.state.approveUuid !== null ? (
          <Redirect
            uuid={this.state.detailUuid}
            to={`/kepegawaian/diklat/teknis.html?approve&uuid=${this.state.approveUuid}`}
          />
        ) : null}
      </>
    );
  }
}

export default TableActiveComponent;
